const VOUCHER_AMOUNT_CONTROL_SELECTOR = '.js-voucher-amount-control'
const VOUCHER_AMOUNT_SELECTOR = '.js-voucher-amount'

const amountControlElements = document.querySelectorAll(VOUCHER_AMOUNT_CONTROL_SELECTOR)
const amountElement = document.querySelector(VOUCHER_AMOUNT_SELECTOR)

export function initVoucherAmount() {
  if (!amountElement) return
  for (const amountControlElement of amountControlElements) {
    amountControlElement.addEventListener('input', () => {
      if (amountControlElement.checked) {
        amountElement.textContent =  amountControlElement.value
      }
    })
  }
}
